import { render, staticRenderFns } from "./ProductionCallWx.vue?vue&type=template&id=273af050"
import script from "./ProductionCallWx.vue?vue&type=script&lang=js"
export * from "./ProductionCallWx.vue?vue&type=script&lang=js"
import style0 from "./ProductionCallWx.vue?vue&type=style&index=0&id=273af050&prod&lang=css"
import style1 from "./ProductionCallWx.vue?vue&type=style&index=1&id=273af050&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports